import { i18n } from "@/framework/plugins/i18n";

function loadCoupon(component: string) {
  // '@' is aliased to src/components
  return () => import(/* webpackChunkName: "[request]" */ `@/modules/coupon/views/${component}.vue`);
}

const env = process.env.VUE_APP_ENV_NAME;
const locale = i18n.locale;

const frontdeskUrl = (env: string = "en"): string => {
  if (env == "prd") {
    return "https://frontdesk.tp.jp.im.kotozna.chat";
  } else {
    return `https://frontdesk.tp.jp.${env}.im.kotozna.chat`;
  }
};

export default [
  {
    path: "coupon/signin",
    name: "coupon-signin",
    meta: { layout: "no-header" },
    component: loadCoupon("SigninCouponView"),
    beforeEnter(to: any, from: any, next: any) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace(`${frontdeskUrl(env)}/${locale || "en"}/login`);
    },
  },
  {
    path: "coupon/signin/confirm",
    name: "coupon-confirm_signin",
    meta: { layout: "no-header" },
    component: loadCoupon("ConfirmSigninCouponView"),
    beforeEnter(to: any, from: any, next: any) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace(`${frontdeskUrl(env)}/${locale || "en"}/login`);
    },
  },
  {
    path: "coupon/searchRoom",
    name: "coupon-search-room-number",
    meta: { layout: "no-header" },
    // beforeEnter: checkSignin,
    component: loadCoupon("SearchRoomAfterSigninView"),
    beforeEnter(to: any, from: any, next: any) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace(`${frontdeskUrl(env)}/${locale || "en"}/overview`);
    },
  },
  {
    path: "coupon/scanQrCode",
    name: "coupon-scan-qr-code",
    meta: { layout: "no-header" },
    // beforeEnter: checkSignin,
    component: loadCoupon("ScanQrCodesView"),
    beforeEnter(to: any, from: any, next: any) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace(`${frontdeskUrl(env)}/${locale || "en"}/overview`);
    },
  },
];
